import { Stack } from 'expo-router';
import { BelieveMakePaymentProvider } from 'features/believe/makePayment/provider/BelieveMakePaymentProvider';
import React from 'react';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import useShouldShowDesktopNavigation from 'shared/hooks/useShouldShowDesktopNavigation';

function BelieveLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  return shouldShowDesktopNavigation ? (
    <BelieveMakePaymentProvider>
      <DesktopNavigation>
        <Stack />
      </DesktopNavigation>
    </BelieveMakePaymentProvider>
  ) : (
    <BelieveMakePaymentProvider>
      <Stack screenOptions={{ headerShown: false }} />
    </BelieveMakePaymentProvider>
  );
}

export default BelieveLayoutWeb;
